export default[
	{
		path:'/',
		name:'main',
		meta:{
			title:'首页'
		},
		component : resolve => require(['COMPONENT/Hello.vue'], resolve)
	},
	{
		path:'/test',
		name:'test',
		meta:{
			title:'Test'
		},
		component : resolve => require(['COMPONENT/Test.vue'], resolve)
	},
	{
		path:'/share',
		name:'share',
		meta:{
			title:'分享测试'
		},
		component : resolve => require(['COMPONENT/Share.vue'], resolve)
	},
	{
		path:'/forum/thread/show',
		name:'forumThreadTest',
		meta:{
			title:'帖子详情'
		},
		component : resolve => require(['PAGE/forum/thread/Show.vue'], resolve)
	},
	{
		path:'/forum/thread/error',
		name:'forumThreadError',
		meta:{
			title:'蜀门手游-错误页面'
		},
		component : resolve => require(['PAGE/forum/thread/Error.vue'], resolve)
	},{
		path:'/forum/self_help/main',
		name:'forumSelf_helpMain',
        meta:{
            title:'蜀门手游-意见反馈'
        },
        component : resolve => require(['PAGE/forum/self_help/Main.vue'], resolve)
	},{
        path:'/forum/big_event/main',
        name:'forumBig_eventMain',
        meta:{
            title:'蜀门手游-大事记'
        },
        component : resolve => require(['PAGE/forum/big_event/Main.vue'], resolve)
    },{
        path:'/forum/chest/main',
        name:'forumChestMain',
        meta:{
            title:'蜀门手游-百宝箱'
        },
        component : resolve => require(['PAGE/forum/chest/Main.vue'], resolve)
    },{
        path:'/forum/raiders/main',
        name:'forumRaidersMain',
        meta:{
            title:'蜀门手游-攻略站'
        },
        component : resolve => require(['PAGE/forum/raiders/Main.vue'], resolve)
    },{
        path:'/forum/labour/main',
        name:'forumLabourMain',
        meta:{
            title:'蜀门手游-公会分享'
        },
        component : resolve => require(['PAGE/forum/labour/Main.vue'], resolve)
	},{
        path:'/activity/welfare',
        name:'ActivityWelfare',
        meta:{
            title:'蜀门手游-福利中心'
        },
        component : resolve => require(['PAGE/activity/Welfare.vue'], resolve)
    },{
        path:'/activity/wish',
        name:'ActivityWish',
        meta:{
            title:'蜀门手游-许愿池'
        },
        component : resolve => require(['PAGE/activity/Wish.vue'], resolve)
    },{
        path:'/forum/means/main',
        name:'forumMeansMain',
        meta:{
            title:'蜀门手游-资料站'
        },
        component : resolve => require(['PAGE/forum/means/Main.vue'], resolve)
    },{
        path:'/forum/writer/main',
        name:'forumWriterMain',
        meta:{
            title:'蜀门手游-写手团报名'
        },
        component : resolve => require(['PAGE/forum/writer/Main.vue'], resolve)
    },
    {
        path:'/forum/answer/main',
        name:'forumAnswerMain',
        meta:{
            title:'蜀门手游-答题器'
        },
        component : resolve => require(['PAGE/forum/answer/Main.vue'], resolve)
    },{
        path:'/forum/means/details',
        name:'forumMeansDetails',
        meta:{
            title:'蜀门手游-资料站'
        },
        component : resolve => require(['PAGE/forum/means/Details.vue'], resolve)
    }, {
        path:'/forum/fate/main',
        name:'forumFateMain',
        meta:{
            title:'蜀门手游-老黄历'
        },
        component : resolve => require(['PAGE/forum/fate/Main.vue'], resolve)
    },
	//转盘抽奖活动
	{
		path:'/activity/lottery',
		name:'activityLottery',
		meta:{
			title:'转盘抽奖'
		},
		component : resolve => require(['PAGE/activity/Lottery.vue'], resolve)
	},{
		path:'/activity/lottery426',
		name:'activityLottery426',
		meta:{
			title:'转盘抽奖'
		},
		component : resolve => require(['PAGE/activity/Lottery426.vue'], resolve)
	},{
        path:'/activity/lottery802',
        name:'activityLottery802',
        meta:{
            title:'转盘抽奖'
        },
        component : resolve => require(['PAGE/activity/Lottery802.vue'], resolve)
    },{
        path:'/activity/lottery180720',
        name:'activityLottery180720',
        meta:{
            title:'转盘抽奖'
        },
        component : resolve => require(['PAGE/activity/Lottery180720.vue'], resolve)
    },{
        path:'/activity/lottery181225',
        name:'activityLottery181225',
        meta:{
            title:'转盘抽奖'
        },
        component : resolve => require(['PAGE/activity/Lottery181225.vue'], resolve)
    },{
        path:'/activity/blessing/blessing',
        name:'activityBlessingBlessing',
        meta:{
            title:'蜀门点赞'
        },
        children:[
            {
                path:'/activity/blessing/send',
                name:'activityBlessingSend',
                meta:{
                    title:'送祝福'
                },
                component : resolve => require(['PAGE/activity/blessing/Send.vue'], resolve)
            },{
                path:'/activity/blessing/top',
                name:'activityBlessingTop',
                meta:{
                    title:'Top祝福'
                },
                component : resolve => require(['PAGE/activity/blessing/Top.vue'], resolve)
            },{
                path:'/activity/blessing/more',
                name:'activityBlessingMore',
                meta:{
                    title:'更多祝福'
                },
                component : resolve => require(['PAGE/activity/blessing/More.vue'], resolve)
            },{
                path:'/activity/blessing/mine',
                name:'activityBlessingMine',
                meta:{
                    title:'我的祝福'
                },
                component : resolve => require(['PAGE/activity/blessing/Mine.vue'], resolve)
            },
        ],
        component : resolve => require(['PAGE/activity/blessing/Blessing.vue'], resolve)
    },{
        path: '/activity/blessing/canvass',
        name: 'activityBlessingCanvass',
        meta: {
            title: '蜀门点赞拉票'
        },
        component: resolve => require(['PAGE/activity/blessing/Canvass.vue'], resolve)
    },{
        path:'/activity/chest',
        name:'activityChest',
        meta:{
            title:'天降宝箱 抢码狂欢'
        },
        component : resolve => require(['PAGE/activity/Chest.vue'], resolve)
    },
	 //激活页面
	 {
		path:'/activity/activation',
		name:'activation',
		meta:{
			title:'确认激活'
		},
		component : resolve => require(['PAGE/activity/Activation.vue'], resolve)
	 },
	// 公会帮助说明页面
	{
		path:'/help/helpexplain',
		name:'helpexplain',
		meta:{
			title:'公会帮助说明'
		},
		component : resolve => require(['PAGE/help/Helpexplain.vue'], resolve)
	},
    // 仅用于公会平台APP帮助说明页面
    {
        path:'/help/helpforguild',
        name:'helpforguild',
        meta:{
            title:'公会平台帮助说明'
        },
        component : resolve => require(['PAGE/help/Helpforguild.vue'], resolve)
    },
    // 公会等级帮助说明页面
    {
        path:'/help/gradeexplain',
        name:'gradeexplain',
        meta:{
            title:'公会等级帮助说明'
        },
        component : resolve => require(['PAGE/help/Gradeexplain.vue'], resolve)
    },
	// 积分规则页面
	{
		path:'/help/pointrule',
		name:'pointrule',
		meta:{
			title:'积分规则'
		},
		component : resolve => require(['PAGE/help/Pointrule.vue'], resolve)
	},{
        path:'/activity/newyear',
        name:'newyear',
        meta:{
            title:'春节活动'
        },
        component : resolve => require(['PAGE/activity/Newyear.vue'], resolve)
    },{
        path:'/activity/photo/photos',
        name:'activityPhotoPhotos',
        meta:{
            title:'爆照活动第一季'
        },
        component : resolve => require(['PAGE/activity/photo/Photos.vue'], resolve)
    },{
        path:'/activity/photo/message',
        name:'activityPhotoMessage',
        meta:{
            title:'爆照活动第一季信息登记'
        },
        component : resolve => require(['PAGE/activity/photo/Message.vue'], resolve)
    },{
        path:'/activity/photo/center',
        name:'activityPhotoCenter',
        meta:{
            title:'爆照活动第一季个人中心'
        },
        component : resolve => require(['PAGE/activity/photo/Center.vue'], resolve)
    },{
        path:'/activity/photo/pagelist',
        name:'activityPhotoPagelist',
        meta:{
            title:'爆照活动第一季展示列表'
        },
        component : resolve => require(['PAGE/activity/photo/Pagelist.vue'], resolve)
    },{
        path:'/activity/photo_two/photos',
        name:'activityPhotoTwoPhotos',
        meta:{
            title:'爆照活动第二季'
        },
        component : resolve => require(['PAGE/activity/photo_two/Photos.vue'], resolve)
    },{
        path:'/activity/photo_two/message',
        name:'activityPhotoTwoMessage',
        meta:{
            title:'爆照活动第二季信息登记'
        },
        component : resolve => require(['PAGE/activity/photo_two/Message.vue'], resolve)
    },{
        path:'/activity/photo_two/center',
        name:'activityPhotoTwoCenter',
        meta:{
            title:'爆照活动第二季个人中心'
        },
        component : resolve => require(['PAGE/activity/photo_two/Center.vue'], resolve)
    },{
        path:'/activity/photo_two/pagelist',
        name:'activityPhotoTwoPagelist',
        meta:{
            title:'爆照活动第二季展示列表',
        },
        component : resolve => require(['PAGE/activity/photo_two/Pagelist.vue'], resolve)
    },{
        path:'/activity/loving/loving',
        name:'activityLovingLoving',
        meta:{
            title:'蜀门表白'
        },
        children:[
            {
                path:'/activity/loving/send',
                name:'activityLovingSend',
                meta:{
                    title:'我要表白'
                },
                component : resolve => require(['PAGE/activity/loving/Send.vue'], resolve)
            },{
                path:'/activity/loving/top',
                name:'activityLovingTop',
                meta:{
                    title:'Top表白'
                },
                component : resolve => require(['PAGE/activity/loving/Top.vue'], resolve)
            },{
                path:'/activity/loving/more',
                name:'activityLovingMore',
                meta:{
                    title:'更多表白'
                },
                component : resolve => require(['PAGE/activity/loving/More.vue'], resolve)
            },{
                path:'/activity/loving/mine',
                name:'activityLovingMine',
                meta:{
                    title:'我的表白'
                },
                component : resolve => require(['PAGE/activity/loving/Mine.vue'], resolve)
            },
        ],
        component : resolve => require(['PAGE/activity/loving/Loving.vue'], resolve)
    },{
        path: '/activity/loving/canvass',
        name: 'activityLovingCanvass',
        meta: {
            title: '蜀门表白拉票'
        },
        component: resolve => require(['PAGE/activity/loving/Canvass.vue'], resolve)
    },{
        path:'/activity/qixi/loving',
        name:'activityQixiLoving',
        meta:{
            title:'七夕活动-仙侣表白'
        },
        component : resolve => require(['PAGE/activity/qixi/Loving.vue'], resolve)
    },{
        path:'/activity/qixi/index',
        name:'activityQixiIndex',
        meta:{
            title:'七夕活动-首页'
        },
        component : resolve => require(['PAGE/activity/qixi/Index.vue'], resolve)
    },{
        path:'/activity/qixi/mine',
        name:'activityQixiMine',
        meta:{
            title:'七夕活动-个人资料'
        },
        component : resolve => require(['PAGE/activity/qixi/Mine.vue'], resolve)
    },{
        path:'/activity/qixi/send',
        name:'activityQixiSend',
        meta:{
            title:'七夕活动-表白'
        },
        component : resolve => require(['PAGE/activity/qixi/Send.vue'], resolve)
    }
]


// WEBPACK FOOTER //
// ./src/routes/app-router.js